import React from 'react'

class View extends React.Component {
	renderCloseButton(){
		return (
			<button aria-label="Close Modal" type="button" className="close" onClick={this.props.onClose && this.props.onClose}>
				<i role="presentation" className="ion-ios-close-empty" onClick={this.clearCustomStyle.bind(this)}/>
			</button>
		)
	}

	initialCustomStyle(){
		this.props.updateCustomStyle({"background": "rgba(13,13,13,0.7)"});
	}

	//clear CustomStyle to avoid effect other popup
	clearCustomStyle(){
		this.props.updateCustomStyle({});
	}

	componentDidMount(){
		this.initialCustomStyle();
	}
	render(){
		const { renderContent } = this.props.args
		return(
			<div className="custom-html-overlay">
				<div className="custom-html">
				{
					renderContent({
						renderCloseButton: () => this.renderCloseButton(),
						closePopup: this.props.onClose
					})
				}
				</div>
			</div>
		)
	}

}

export default View;